import React from 'react';
import { classNames } from '@/utils';
import { ProgressCSSProperties } from '@/types';

export interface LoaderProps {
  percentage?: number;
  className?: string;
}

export function Loader({ percentage = 30, className }: LoaderProps) {
  return (
    <div className={classNames('loader-container', className)}>
      <figure className="loader">
        <span className="loading-level" style={{ '--percent': `${percentage}%` } as ProgressCSSProperties} />
      </figure>
    </div>
  );
}
